import { CheckCircle2, AlertTriangle, Clock } from "lucide-react";
import { Card } from "@/components/ui/card";

const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("pt-BR", { day: "2-digit", month: "short" });
  } catch {
    return "—";
  }
};

function Kpi({ icon: Icon, label, value, color }) {
  return (
    <div className="flex flex-col items-center gap-1 py-2 px-3 rounded-lg bg-surface-card-hover">
      <Icon className={`w-4 h-4 ${color}`} />
      <div className="text-lg font-bold text-foreground leading-none">{value ?? 0}</div>
      <div className="text-[10px] text-foreground-muted text-center">{label}</div>
    </div>
  );
}

export default function TaskOverviewCard({ data }) {
  const upcoming = data?.upcoming || [];
  return (
    <Card variant="elevated" className="p-4 max-w-md">
      <div className="text-xs text-foreground-muted mb-2">Suas tarefas</div>
      <div className="grid grid-cols-3 gap-2 mb-3">
        <Kpi
          icon={Clock}
          label="Pendentes"
          value={data?.pending}
          color="text-indigo-400"
        />
        <Kpi
          icon={AlertTriangle}
          label="Atrasadas"
          value={data?.overdue}
          color="text-red-400"
        />
        <Kpi
          icon={CheckCircle2}
          label="Concluídas (semana)"
          value={data?.done_this_week}
          color="text-emerald-400"
        />
      </div>

      {upcoming.length > 0 && (
        <div className="space-y-1">
          <div className="text-[10px] text-foreground-muted uppercase tracking-wider mb-1">
            Próximas
          </div>
          {upcoming.slice(0, 4).map((t) => (
            <div
              key={t.id}
              className="flex items-center justify-between py-1.5 px-3 rounded-lg bg-surface-card-hover"
            >
              <div className="min-w-0 mr-2">
                <div className="text-xs text-foreground truncate">{t.title}</div>
              </div>
              <div className="text-[10px] text-foreground-muted whitespace-nowrap">
                {fmtDate(t.datetime_due)}
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
